import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import Typography from '@material-ui/core/Typography';

// UTILITY
import { analyticsNoSearchResults } from '@/utility/analytics';

// STYLES
import { Container } from './styles';

const NoResults = ({ search }) => {
  const [t] = useTranslation();

  React.useEffect(() => {
    analyticsNoSearchResults({ query: search });
  }, []);

  return (
    <Container className="no-results">
      <Typography className="m-b-10" align="center" variant="h4">
        {t('searchPage.noResults.title', { search })}
      </Typography>
      <Typography className="p4" align="center">
        {t('searchPage.noResults.description')}
      </Typography>
    </Container>
  );
};

NoResults.defaultProps = {
  search: '',
};

NoResults.propTypes = {
  search: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
};

export default React.memo(NoResults);
